import { INetwork, Network } from "relay-runtime";

import createMiddlewareStack from "@framework/relay/shared/createMiddlewareStack";
import { HydrationData } from "@framework/relay/shared/hydration";

import createBrowserMiddlewareList from "./createBrowserMiddlewareList";

export default function createBrowserNetwork({
  hydrationData,
  communityId,
  token,
  origin,
}: {
  hydrationData: HydrationData;
  communityId: number;
  token?: string;
  origin?: string;
}): INetwork {
  const middleware = createBrowserMiddlewareList({
    hydrationData,
    communityId,
    token,
  });

  let endpoint = "/api/graphql";

  if (origin) {
    endpoint = `${origin}${endpoint}`;
  }

  return Network.create(
    createMiddlewareStack({
      url: endpoint,
      middleware,
    }),
  );
}
